module.exports = __webpack_public_path__ + "static/media/rats.45e86177.mp3";